import lottie from 'lottie-web/build/player/lottie_light';

export const hero = () => {

  const lottieContainer = document.getElementById('hero__animation-container');

  console.log('Hero animation script loaded');
  console.log('Looking for element with ID: hero__animation');
  console.log('Found element:', lottieContainer);

  if (lottieContainer) {
    console.log('Container found, loading Lottie animation...');

    try {
      const animation = lottie.loadAnimation({
        container: lottieContainer, // The container element
        renderer: 'svg', // Render type: 'svg', 'canvas', or 'html'
        loop: true, // Set to false for one-time play
        autoplay: true, // Start automatically
        path: '/wp-content/themes/warburg-pincus-wealth-solutions/lib/lottie/hero.json', // Path to the animation file
        rendererSettings: {
          preserveAspectRatio: 'xMaxYMin meet', // Top right aligned, height fills container, width auto
        }
      });

      animation.setSpeed(0.15);

      console.log('Animation loaded successfully:', animation);

      // Add event listeners for debugging
      animation.addEventListener('complete', () => {
        console.log('Animation completed');
      });

      animation.addEventListener('loopComplete', () => {
        console.log('Animation loop completed');
      });

      animation.addEventListener('data_ready', () => {
        console.log('Animation data ready');
      });

      animation.addEventListener('DOMLoaded', () => {
        console.log('Animation DOM loaded');
      });

    } catch (error) {
      console.error('Error loading Lottie animation:', error);
    }

  } else {
    console.warn('Hero animation container not found! Make sure the element with ID "hero__animation" exists.');
  }
}